export default __webpack_public_path__ + "ac6aedba4ff27233b5d21c9da9b9dbfd.png";